<script lang="ts">
  import { flip } from "svelte/animate";
  import { cubicOut } from "svelte/easing";
  import Toast from "./Toast.svelte";
  import { dismissToast, toasts } from "./store";
</script>

{#if $toasts.length}
  <section aria-live="polite" aria-atomic="true">
    {#each $toasts as toast (toast.id)}
      <div class="toast-item" animate:flip={{ duration: 280, easing: cubicOut }}>
        <Toast
          type={toast.type}
          dismissible={toast.dismissible}
          on:dismiss={() => dismissToast(toast.id)}
        >
          {toast.message}
        </Toast>
      </div>
    {/each}
  </section>
{/if}

<style>
  section {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    display: flex;
    margin-bottom: 1rem;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    z-index: 1000;
    pointer-events: none;
  }

  .toast-item {
    pointer-events: auto;
    will-change: transform;
  }
</style>
